import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

interface StyleNotesProps {
  notes: string;
}

const StyleNotes: React.FC<StyleNotesProps> = ({ notes }) => {
  if (!notes) return null;

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Style Notes</Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="body1" sx={{ lineHeight: 1.7 }}>{notes}</Typography>
      </Paper>
    </Box>
  );
};

export default StyleNotes;
